import React, { FC, useEffect } from 'react';
import { PrimaryButton } from '@clover/web-lib-core/components';
import { isInstallAppButtonDisabled } from '../../../component-helpers/app-actions';
import { AppActions } from './types';
import { App } from '../../../models/app';
import { useTranslation } from 'react-i18next';
import { usePermission } from '../../../hooks/usePermission';
import { AppMarketPermissions } from '../../../models/enums';
import { useMerchantDelinquencyStatus } from '../../../hooks/useMerchantDelinquencyStatus';
import { useAppInstallRequiresAnotherPlan } from '../../../hooks/useAppInstallRequiresAnotherPlan';
import { getAppDetailsRedirectedInfo,removeAppDetailsRedirectedInfo } from '../../../utils/session';

interface ComponentProps {
  app: App;
  actionHandler: () => void;
}

const PreInstallConnectButton: FC<ComponentProps> = ({app , actionHandler}) => {
  const { t } = useTranslation();
  const { enabled: hasInstallUninstallPermission } = usePermission(AppMarketPermissions.InstallUninstallApps);
  const isMerchantDelinquent = useMerchantDelinquencyStatus();
  const { requiresAnotherPlan } = useAppInstallRequiresAnotherPlan(app);
  const { autoInstall} = getAppDetailsRedirectedInfo();
  const isButtonDisabled =  isInstallAppButtonDisabled(app, hasInstallUninstallPermission, isMerchantDelinquent, requiresAnotherPlan)


  useEffect(() => {
    if(autoInstall && !app?.installed) {
      /* when the app is not installed and connect button is not disabled- Modal will open for selecting the subscription */
      if(!isButtonDisabled){
        actionHandler();
      }else{
        /* when the app is not installed and connect button is disabled i.e. incase of HIPPA enabled merchant- Modal will not open. */
        removeAppDetailsRedirectedInfo();
      }
    }
  }, [autoInstall,app,isButtonDisabled,actionHandler]);
  return (
    <PrimaryButton
      disabled={isInstallAppButtonDisabled(app, hasInstallUninstallPermission, isMerchantDelinquent, requiresAnotherPlan)}
      onClick={actionHandler}
    >
      {t(AppActions.PreInstall)}
    </PrimaryButton>
  );
};

export default PreInstallConnectButton;
